<div class="illustrations-container">
  

  <!-- Shared Filters Section -->
  <div class="shared-filters-section">
    <app-shared-filters
      [pageName]="'illustrations'"
      [stickyOffset]="20"
      [initialFilter]="currentSharedFilter"
      [showOnlySearch]="false"
      [hideProductFields]="true"
      [hidePolicyNumberField]="true"
      [customSearchPlaceholder]="'Keresés cégnevekre, ügyfelekre és elérhetőségekre...'"
      [customStatusOptions]="customKumOptions"
      [customStatusLabel]="'KÜM'"
      [customBiztositoOptions]="customAreaOptions"
      [customBiztositoLabel]="'Terület'"
      [customDateFromLabel]="'Kapcs.felv. ideje'"
      [customDateToLabel]="'Kiküldés napja'"
      [lockStatusFilter]="lockKumFilter"
      [showIllustrationStatusFilter]="true"
      [illustrationStatusOptions]="illustrationStatusOptions"
      (filterChange)="onSharedFilterChange($event)"
      (clearFilters)="onSharedFilterClear()">
    </app-shared-filters>
  </div>

  <!-- Page Header -->
  <div class="page-header">
    <div class="page-title">
      <h2>Ajánlatillusztrációk</h2>
      <div class="header-actions">
        <span class="record-count">{{dataSource.filteredData.length}} / {{dataSource.data.length}} rekord</span>
        <button mat-raised-button color="primary" class="new-illustration-btn" (click)="createNewIllustration()">
          <mat-icon>add</mat-icon>
          Új illusztráció
        </button>
      </div>
    </div>
  </div>

  <!-- Data Table -->
  <app-illustrations-table 
    [dataSource]="dataSource"
    [totalIllustrations]="totalIllustrations"
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    (pageChange)="onPageChange($event)"
    (statusUpdated)="onStatusUpdated()">
  </app-illustrations-table>
</div>
